export class TaskMessage {
  eventName: string;
  message: string;
  creationDate: Date;
  statusCode: string;
  processedDate: Date;
  errorMessage: string;
}
